const url = window.location.href;
export const isLocalDevelopment = url.startsWith('http://localhost') || url.startsWith('http://127.0.0.1');
